import { render, staticRenderFns } from "./PointsTable.vue?vue&type=template&id=d7925a8e"
import script from "./PointsTable.vue?vue&type=script&lang=js"
export * from "./PointsTable.vue?vue&type=script&lang=js"
import style0 from "./PointsTable.vue?vue&type=style&index=0&id=d7925a8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports